import { render } from "./RegistOneClassAdult.vue?vue&type=template&id=02aa1a62"
import script from "./RegistOneClassAdult.vue?vue&type=script&lang=js"
export * from "./RegistOneClassAdult.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__